// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"2c7892f1","218":"47fad71f","250":"cd47806b","461":"472d9d69","462":"509ac505","648":"3f92b751","693":"7a31d309","884":"7d40fbde","983":"53a008b4"}[chunkId] + ".chunk.js";
};